import { ChevronLeft } from '@material-ui/icons';
import { Avatar } from '@mui/material';
import React, { useState } from 'react';
import dateFormat from 'dateformat';

const DailyReport = ({ report }) => {
  const [display, setDisplay] = useState(false);

  return (
    <div className="col-lg-4 p-2 col-12 col-md-6">
      <div className="shadow p-3">
        <div className="d-flex click" onClick={() => setDisplay(!display)}>
          <Avatar src={report.profile_pic || null} />
          <div className="text-center ms-2">
            <h5>{report.create_datetime ? dateFormat(report.create_datetime, 'dS mmm yyyy') : 'N/A'}</h5>
            <p className="mr-4 mb-0">Reported by {report.reported_by || 'Unknown'}</p>
          </div>
        </div>

        {display && (
          <>
            <hr />
            <p>{report.report || 'No report content'}</p>
            <div className="d-flex">
              <p className="text-secondary">
                Reported Time: {report.create_datetime ? report.create_datetime : 'N/A'}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DailyReport;